import { baseUrl } from './baseUrlProvider';
import { get } from './globalConfig';

const BASE_URL = baseUrl(window.location.hostname);

const retrieveJWT = (refresh: boolean = false): Promise<string> => {
  const tokenProviderFunc = get('tokenProvider');
  if (!tokenProviderFunc) {
    return Promise.reject(
      'No JWT was provided. Please use setTokenProvider().'
    );
  }
  return tokenProviderFunc(refresh);
};

const fetchWithJWT = (
  ref: string,
  data: any,
  userJWT: string
): Promise<any> => {
  const Authorization = `Bearer ${userJWT}`;
  const Accept = 'application/json';

  const payload = JSON.parse(JSON.stringify(data));
  payload.headers = payload.headers ? payload.headers : {};
  payload.headers = Object.assign(payload.headers, { Authorization, Accept });

  return fetch(ref, payload)
    .then(response => {
      if (response.status > 199 && response.status < 300) {
        return response;
      }
      throw response;
    })
    .then(response => {
      if (response.status === 204) {
        return {};
      } else if (response.hasOwnProperty('json')) {
        return response.json();
      } else {
        return response;
      }
    });
};

const retryIfUnauthorized = (
  url: string,
  payload: any,
  data: any
): Promise<any> => {
  if (data.status === 401) {
    return retrieveJWT(true).then((userJWT: string) =>
      fetchWithJWT(url, payload, userJWT)
    );
  }
  throw data;
};

export const fetchResource = (ref = BASE_URL, data = {}): Promise<any> =>
  retrieveJWT()
    .then((userJWT: string) => fetchWithJWT(ref, data, userJWT))
    .catch((response: any) => retryIfUnauthorized(ref, data, response));
